import React from "react"
import { GroupMember } from "firebase/groupsService"
import strings from "utils/strings"

export const AVATAR_COLORS: [string, string][] = [
	["#2B6CF4", "#1A4ED8"],
	["#7C3AED", "#5B21B6"],
	["#059669", "#047857"],
	["#DC2626", "#B91C1C"],
	["#D97706", "#B45309"],
	["#0891B2", "#0E7490"],
	["#DB2777", "#BE185D"],
	["#65A30D", "#4D7C0F"],
]

export function formatTime(date: Date): string {
	return date.toLocaleTimeString("pt-PT", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	})
}

export function formatDate(date: Date): string {
	const now = new Date()
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	const yesterday = new Date(today.getTime() - 86400000)
	const d = new Date(date.getFullYear(), date.getMonth(), date.getDate())

	if (d.getTime() === today.getTime()) return strings.messaging.today
	if (d.getTime() === yesterday.getTime()) return strings.messaging.yesterday
	return date.toLocaleDateString("pt-PT", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	})
}

export function isSameDay(a: Date, b: Date): boolean {
	return (
		a.getFullYear() === b.getFullYear() &&
		a.getMonth() === b.getMonth() &&
		a.getDate() === b.getDate()
	)
}

export function getInitials(name: string): string {
	return name
		.split(" ")
		.slice(0, 2)
		.map((w) => w[0])
		.join("")
		.toUpperCase()
}

export function getAvatarColors(name: string): [string, string] {
	let hash = 0
	for (let i = 0; i < name.length; i++)
		hash = name.charCodeAt(i) + ((hash << 5) - hash)
	return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

// Render text with @mention highlighting.
// Uses known member names (sorted longest-first) to build an exact regex
// so that multi-word names like "@José Gomes Driver" are highlighted in full.
export function renderTextWithMentions(
	text: string,
	variant: "me" | "other" | "bot",
	members: GroupMember[] = []
): React.ReactNode {
	let parts: string[]

	if (members.length > 0) {
		const sorted = [...members]
			.map((m) => m.name)
			.sort((a, b) => b.length - a.length)
			.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
		const regex = new RegExp(`(@(?:${sorted.join("|")}))`, "gi")
		parts = text.split(regex)
	} else {
		parts = text.split(/(@\S+)/g)
	}

	const lowerNames = new Set(members.map((m) => m.name.toLowerCase()))

	return (
		<>
			{parts.map((part, i) => {
				const isMention =
					part.startsWith("@") &&
					(members.length === 0 || lowerNames.has(part.slice(1).toLowerCase()))
				return isMention ? (
					<span key={i} className={`mention mention--${variant}`}>
						{part}
					</span>
				) : (
					part
				)
			})}
		</>
	)
}
